import { DialogContent, DialogHeader, DialogTitle, Button, Dialog } from '@ui/components';
import { OnboardingVehicleDto } from '@interfaces/models';
import { Delete } from '@ui/components/icons';
import { useEffect, FC } from 'react';
import { t } from 'i18next';

import { EmployeeFormType, useEmployeeForm } from '../../../hooks';
import { EmployeeForm } from '../employee-form/employee-form';

interface EditEmployeeDialogProps {
  onSave: (employee: EmployeeFormType) => void;
  onOpenChange: (open: boolean) => void;
  availableVehicles?: OnboardingVehicleDto[];
  onRemove: () => void;
  employee: EmployeeFormType;
  open: boolean;
}

export const EditEmployeeDialog: FC<EditEmployeeDialogProps> = (props) => {
  const { onOpenChange, open, employee, onSave, onRemove, availableVehicles } = props;
  const { form } = useEmployeeForm();

  const handleSubmitEditedEmployee = (modifiedEmployee: EmployeeFormType) => {
    onSave(modifiedEmployee);
  };

  // Set form values when dialog is opened
  useEffect(() => {
    form.reset(employee);
  }, [employee, form]);

  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open) {
          form.reset(employee);
        }

        onOpenChange(open);
      }}
      open={open}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.ADD_EMPLOYEES.EDIT')}</DialogTitle>
          <Button className="ml-auto" onClick={onRemove} variant="ghost">
            <Delete className="size-4" />
          </Button>
        </DialogHeader>

        <div className="p-4">
          <EmployeeForm
            availableVehicles={availableVehicles}
            onSubmit={handleSubmitEditedEmployee}
            form={form}
          />
          <Button
            onClick={form.handleSubmit(handleSubmitEditedEmployee)}
            type="submit"
            size="large"
            wide
          >
            {t('ONBOARDING.ADD_EMPLOYEES.SAVE')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
